import { Component, OnInit, Inject, Renderer2 } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MotivosCancelacion, TipoDeComprobante } from 'app/shared/enum.shared';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';


@Component({
  selector: 'app-cancela-cfdi4',
  templateUrl: './cancela-cfdi4.component.html',
  styleUrls: ['./cancela-cfdi4.component.scss']
})
export class CancelaCFDI4Component implements OnInit {
    cancelReasonForm: FormGroup;
    cancelReasons: any[] = [];
    showUuidInput: boolean = false;
    uuidPattern: RegExp;
    showInput: boolean = true;
    idEmpresa: number;
    invoicesOptions: any[] = [];


    constructor(
        private dialogRef: MatDialogRef<CancelaCFDI4Component>, 
        private snackBar: MatSnackBar,
        private coalService: CoalService,
        private store: Store,
        private renderer: Renderer2,
        @Inject(MAT_DIALOG_DATA) public data: any
        ) {
            if (data) {
                this.idEmpresa = data.idEmpresa
            }
         }

    ngOnInit(): void {
        this.apiGetMotivoCancelacion();

        this.uuidPattern = /^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}$/

        this.cancelReasonForm = new FormGroup({
            cancelReason: new FormControl(MotivosCancelacion.OperacionNoRealizada, Validators.required),
            relatedCFDI: new FormControl('', [Validators.required]),
        });

        this.cancelReasonForm.get('relatedCFDI').disable();
    }

    onCancelReasonChange(): void {
        this.showUuidInput = this.cancelReasonForm.value.cancelReason == MotivosCancelacion.ErrorConRelacion;
        if (!this.showUuidInput) {
            this.cancelReasonForm.get('relatedCFDI').disable();
            this.cancelReasonForm.get('relatedCFDI').clearValidators();
            this.cancelReasonForm.controls.relatedCFDI.reset();
        } else {
            this.cancelReasonForm.get('relatedCFDI').enable();
            this.cancelReasonForm.get('relatedCFDI').setValidators([Validators.required, Validators.pattern(this.uuidPattern)]);
            this.cancelReasonForm.controls.relatedCFDI.setValidators([Validators.required, Validators.pattern(this.uuidPattern)]);
        }
    }

    submitForm(): void {
        if (this.cancelReasonForm.valid) {
            // Procesar el formulario
            console.log(this.cancelReasonForm.value);
        }
    }

    closeDialog(): void {
        this.dialogRef.close({ success: 0, data: null });
    }

    optionSelected(event) {
        this.cancelReasonForm.controls.relatedCFDI.setValue(event?.option?.value?.attributes?.fac_factura_timbre?.data?.attributes?.uuid);
    }

    acceptDialog(): void {
        if (this.cancelReasonForm.valid) {
            this.dialogRef.close({ success: 1, data: {
                relatedCFDI: this.cancelReasonForm.value.relatedCFDI?.attributes?.fac_factura_timbre?.data?.attributes?.uuid || this.cancelReasonForm.value.relatedCFDI,
                cancelReason: this.cancelReasons.find(x => x.id == this.cancelReasonForm.value.cancelReason)?.attributes?.clave
            }}
            );
        }
        else{
            this.snackBar.open('El formulario no es válido. Por favor, revisa los campos.', 'Aceptar', {
                duration: 2000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
            });
        }
    }

    apiGetMotivoCancelacion(){
        this.store.dispatch(MostrarSpinner());
        this.coalService.getService(`cat-motivo-cancelacions`,).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(OcultarSpinner());
            } else if (res.excepcion) {
                this.store.dispatch(OcultarSpinner());
            } else {
                this.cancelReasons = res.data;
                setTimeout(() => {
                    this.cancelReasonForm.controls['cancelReason'].setValue(MotivosCancelacion.OperacionNoRealizada);
                }, 500);
				this.store.dispatch(OcultarSpinner());
            };
        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
        });
        
    }

    eraseRelatedInvoices() {
        this.showInput = true;
        this.cancelReasonForm.controls.relatedCFDI.setValue(null);
    }

    displayFn(id: any): string {
        if (id?.attributes) {
            return id?.attributes?.fac_factura_timbre?.data?.attributes?.uuid || '';
        } else {
            return id;
        }
    }

    getRelatedInvoices(event) {
        const value = event?.target?.value;
        if (this.uuidPattern.test(value)) {
            return;
        }
        this.store.dispatch(MostrarSpinner());
        this.coalService.getService(`fac-facturas?filters[ope_empresa][id]=${this.idEmpresa}&filters[cat_tipo_comprobante][id]=${TipoDeComprobante.Factura}&filters[fac_factura_timbre][id][$notNull]=true&populate=fac_factura_productos.pro_producto.cat_objeto_impuesto,fac_factura_timbre,ope_empresa,cli_cliente&filters[$or][0][cli_cliente][rfc][$contains]=${value}&filters[$or][1][fac_factura_timbre][uuid][$contains]=${value}&filters[$or][2][cli_cliente][nombre][$contains]=${value}`)
        .subscribe((res: any) => {
            this.store.dispatch(OcultarSpinner());
            this.showInput = false;
            this.invoicesOptions = res.data;

            setTimeout(() => {
                //this.myInputClave.nativeElement.focus();
                var element = this.renderer.selectRootElement('#myInvoiceInput');
                element.focus();
            }, 500);
        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
        })
    }


}
